import type { Typography } from '../../style/color';

const RcmReportTypography: Typography = {
  fontFamily: 'Inter, system-ui, sans-serif',
};

export default RcmReportTypography;
